<div class="upload-dialog">
  @if (isUploading) {
    <div class="progress-bar-container">
      <svg>
        <circle cx="50" cy="50" r="50"></circle>
        <circle [style]="getProgressStyle(progress)" cx="50" cy="50" r="50"></circle>
      </svg>
      <span class="progress-bar-counter">
        {{ progress }}%
      </span>
    </div>

    @if (files?.length > 1) {
      <p i18n="@@ZagruzhaemIz">Загружаем {{ loaded + 1 }} из {{ files.length }} {{ createLabel(loaded, filesPlural, false) }}</p>
    } @else {
      <p i18n="@@ZagruzhaemFayl">Загружаем файл</p>
    }

  } @else if (!finished) {
    <app-uploader [accept]="accept" (upload)="onSubmit($event)" [allowedMimeType]="allowedMimeType" [maxFileSize]="maxFileSize" [multiple]="multiple" size="l"/>

  } @else {
    @if (loaded) {
      <p i18n="@@ZagruzkaZavershena2">Загрузка завершена. {{ createLabel(loaded, uploadedPlural, false) }} {{ createLabel(loaded, filesPlural) }} </p>
    }

    <button nbButton (click)="reset()" i18n="@@ZagruzitEsche">
      <tui-icon icon="repeat"/>
      Загрузить еще
    </button>
  }
</div>
